import { Formik } from 'formik';
import React, { Component, } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from "lodash";
import moment from "moment";
import { PrimaryButton, ButtonSizeOptions, SecondaryButton } from '@loanbossinc/component-library';
import { calculateCap } from 'store/state/calculators/capPricer';
import { downloadCapPricerTestData } from "store/state/calculators/testHarness";
import styled from 'styled-components';
import { DatePicker, MoneyInput, IntegerInput, PercentInput, AutoCompleteInput } from 'components/Global/FormikMaterial';
import { Grid } from '@material-ui/core';
import ratingTriggers from 'constants/ratingTriggers';
import {
  transformDecimal,
  transformInteger,
  transformRate
} from 'utils/formTransformers';

const CapFormGrid = styled(Grid)`
  &&{
    min-width:200px;
    max-height:70px;
    margin-bottom:12px;
  }
`
const PaddedGrid = styled(Grid)`
  && {
    padding:0 20px 20px 20px;   
  }  
`;

const ButtonGrid = styled(Grid)`
  && {
    margin-top:20px;
  }
`;

const ButtonBar = styled(Grid)`
  && > *:first-child {
    margin-right: 12px;
  }
`
const StyledLabel = styled.div`{
  //styleName: Work Sans / 16 Medium;
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
 }`;
class CapForm extends Component {
  initialValues = {
    effectiveDate: moment(Date.now()).format('YYYY-MM-DD'),
    notional: '',
    term: '',
    strike: '',
    ratingTriggers: ''
  }
  createPayload = (values) => {
    let modifiedValues = { ...values };
    modifiedValues.effectiveDate = moment(_.get(modifiedValues, 'effectiveDate')).format('YYYY-MM-DD');
    modifiedValues.notional = transformDecimal(modifiedValues.notional);
    modifiedValues.term = transformInteger(modifiedValues.term);
    modifiedValues.strike = transformRate(modifiedValues.strike);
    modifiedValues.ratingTrigger = this.transformRatingTrigger(modifiedValues.ratingTriggers);
    modifiedValues.isDebug = true;
    return modifiedValues;
  }
  calculate = (values) => {
    let payload = this.createPayload(values);
    this.props.calculateCap(payload);
  }

  transformRatingTrigger = trigger => {
    if (!trigger)
      return "Not Selected";

    const foundTriggers = ratingTriggers.list.filter(x => x.value === trigger);
    if (foundTriggers.length > 0) {
      return foundTriggers[0].label;
    }
  }


  handleDownload = (values) => {
    let payload = this.createPayload(values);
    this.props.downloadCapPricerTestData(payload);
  }

  render() {
    return (
      <Formik
        initialValues={this.initialValues}
        enableReinitialize
        validateOnChange={true}
        validate={values => {
          let errors = {
          }
          let term = transformInteger(values.term);
          if (term > 84) {
            errors.term = "Max term is 84 months";
          } else {
            delete errors.term;
          }
          let strike = transformRate(values.strike);
          if (values.strike && (strike < 0.0 || strike > 0.06)) {
            errors.strike = "Strike must be between 0% and 6%"
          } else {
            delete errors.strike;
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          this.calculate(values);
          setSubmitting(false);
        }}
        render={({ values, errors, status, touched, isSubmitting, handleChange, handleBlur, handleSubmit }) => (
          <PaddedGrid container item xs={3} md={4} lg={4} direction="column" spacing={32}>
            <CapFormGrid item xs={2}>
              <DatePicker
                fullWidth
                label={<StyledLabel>{"Start Date"}</StyledLabel>}
                fieldName="effectiveDate" />
            </CapFormGrid>
            <CapFormGrid item xs={2}>
              <MoneyInput
                fullWidth
                label={<StyledLabel>{"Notional"}</StyledLabel>}
                fieldName="notional" />
            </CapFormGrid>
            <CapFormGrid item xs={2}>
              <IntegerInput
                fullWidth
                label={<StyledLabel>{"Term (m)"}</StyledLabel>}
                fieldName="term" />
            </CapFormGrid>
            <CapFormGrid item xs={2}>
              <PercentInput
                fullWidth
                label={<StyledLabel>{"Strike"}</StyledLabel>}
                fieldName="strike" />
            </CapFormGrid>
            <CapFormGrid item xs={2}>
              <AutoCompleteInput
                fullWidth
                label={<StyledLabel>{"Rating Triggers"}</StyledLabel>}
                fieldName="ratingTriggers"
                selectName="name"
                selectValue="value"
                options={ratingTriggers.list} />
            </CapFormGrid>

            <ButtonGrid container alignItems="center" spacing={8}>
              <ButtonBar item xs={12}>
                <PrimaryButton
                  style={{ marginRight: 24 }}
                  label="Calculate"
                  onClick={handleSubmit}
                  size={ButtonSizeOptions.smFluid}
                />
                <SecondaryButton
                  label="Download"
                  onClick={() => this.handleDownload(values)}
                  size={ButtonSizeOptions.smFluid}
                />
              </ButtonBar>
            </ButtonGrid>
          </PaddedGrid>
        )} />
    )
  }
}
const mapStateToProps = state => {
  const { loading } = state;
  return {
    loading,
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      calculateCap,
      downloadCapPricerTestData
    }
  ),
)(CapForm);